export default "/images/vendor/@coreui/icons/svg/flag/cif-lr.svg?1bde6a27125f4e9e765c26f4c2c6fae1";